import gql from 'graphql-tag';

export const hasControllerAcknowledgedDOP = gql`
  query hasControllerAcknowledgedDOP(
    $aorId: String
    $contactId: String
    $shiftDate: String
  ) {
    hasControllerAcknowledgedDOP(
      aorId: $aorId
      contactId: $contactId
      shiftDate: $shiftDate
    ) {
      value
    }
  }
`;
